import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { Check, Target, ArrowRight, MapPin, CalendarCheck, Package } from "lucide-react";
import { ExternalCta } from "@/components/common/ExternalCta";

export const ServiceCard = ({ item }) => {
  const Icon = Icons[item.icon] || Icons.Dumbbell;
  return (
    <div
      className="group flex flex-col overflow-hidden rounded-xl border border-border bg-card transition-colors duration-200 hover:border-[hsl(var(--brand-red))]"
      data-testid="service-card"
    >
      {item.image_url && (
        <div className="relative h-44 overflow-hidden">
          <img
            src={item.image_url}
            alt={item.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
          <div className="absolute left-3 top-3 flex h-10 w-10 items-center justify-center rounded-md bg-brand text-white">
            <Icon className="h-5 w-5" />
          </div>
          <h3 className="absolute bottom-3 left-4 right-4 display-title text-2xl leading-tight text-white">{item.title}</h3>
        </div>
      )}

      <div className="flex flex-1 flex-col p-5">
        <p className="text-sm leading-relaxed text-muted-foreground">{item.description}</p>

        {item.who_for && (
          <div className="mt-4">
            <p className="font-condensed text-xs font-semibold uppercase tracking-[0.18em] text-brand">Who It's For</p>
            <p className="mt-1 text-sm text-foreground/90">{item.who_for}</p>
          </div>
        )}

        {Array.isArray(item.highlights) && item.highlights.length > 0 && (
          <div className="mt-4">
            <p className="font-condensed text-xs font-semibold uppercase tracking-[0.18em] text-brand">Main Benefits</p>
            <ul className="mt-1.5 space-y-1.5">
              {item.highlights.map((h) => (
                <li key={h} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Check className="h-4 w-4 shrink-0 text-brand" />{h}
                </li>
              ))}
            </ul>
          </div>
        )}

        {item.next_step && (
          <div className="mt-4 flex items-start gap-2 rounded-lg border border-border bg-background/50 p-3">
            <Target className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
            <p className="text-sm text-foreground/90"><span className="font-semibold">Next step:</span> {item.next_step}</p>
          </div>
        )}

        {item.location && (
          <p className="mt-4 flex items-center gap-1.5 text-xs text-muted-foreground">
            <MapPin className="h-3.5 w-3.5 text-brand" />{item.location}
          </p>
        )}

        {/* Spacer pushes buttons to bottom for equal-height cards */}
        <div className="flex-1" />

        <div className="mt-5 grid grid-cols-2 gap-2.5">
          <ExternalCta
            href={item.booking_url}
            variant="primary"
            showIcon={false}
            testid="service-book-btn"
            className="px-3 py-2.5 text-xs"
          >
            <CalendarCheck className="h-4 w-4" /> Book
          </ExternalCta>
          <Link
            to="/packages"
            data-testid="service-packages-btn"
            className="inline-flex items-center justify-center gap-2 rounded-md border border-border bg-transparent px-3 py-2.5 text-xs font-semibold uppercase tracking-wide text-foreground transition-colors duration-200 hover:bg-accent active:scale-[0.98]"
          >
            <Package className="h-4 w-4 text-brand" /> Packages
          </Link>
        </div>
      </div>
    </div>
  );
};
